interface ClientInfoCardProps {
  client: {
    name: string;
    email: string;
    phone: string;
  };
}

export const ClientInfoCard = ({ client }: ClientInfoCardProps) => {
  return (
    <div className="bg-white p-3.5 rounded-xl border border-gray-200">
      <h3 className="text-sm font-bold text-gray-900 mb-2">Client Info</h3>
      <div className="space-y-2 text-sm text-gray-600">
        <p className="flex items-center gap-2">
          <span className="material-symbols-outlined text-base">person</span>
          {client.name}
        </p>
        <p className="flex items-center gap-2">
          <span className="material-symbols-outlined text-base">mail</span>
          <a href={`mailto:${client.email}`} className="hover:text-primary hover:underline">
            {client.email}
          </a>
        </p>
        <p className="flex items-center gap-2">
          <span className="material-symbols-outlined text-base">phone</span>
          <a href={`tel:${client.phone}`} className="hover:text-primary hover:underline">
            {client.phone}
          </a>
        </p>
      </div>
    </div>
  );
};


